import {
	Component,
	Input,
	ViewEncapsulation,
	Output,
	EventEmitter,
	ViewChild,
	ElementRef,
	forwardRef,
	OnDestroy,
	ChangeDetectorRef,
	ChangeDetectionStrategy,
	Self,
	Optional
} from "@angular/core";
import { IdService } from "../shared/services/id.service";
import { ControlValueAccessor, NgControl } from "@angular/forms";
import { IAutocompleteOption } from "./autocomplete.types";

@Component({
	selector: "rbc-autocomplete",
	templateUrl: "./autocomplete.component.html",
	styles: [],
	encapsulation: ViewEncapsulation.None
})
export class AutocompleteComponent implements ControlValueAccessor, OnDestroy {
	@Input() customLookup: any[] = ["key", "value"];
	@Input() helpText: string;
	@Input() id: string;
	@Input() label: string;
	@Input() placeholder = "";
	@Input() displayKey = true;
	@Input() showAll = false;
	@Input() triggerAfter: string | number = 2;
	@Input() maxResults = -1;
	@Input() height;
	@Input() required: boolean;
	@Input() showRequired: boolean;
	@Input() keepOpen = false;
	@Input() disabled = false;
	@Input() noResultsText = "No Results Found";
	@Input() size: 'small'| 'medium'| 'large' = "medium"
	@Input() tags: boolean;
	@Input() langauge = 'en';
	@Input() ariaInvalid;
	@Input() clearAfter: boolean;

	@Output() selected = new EventEmitter();
	@Output() onInput = new EventEmitter();
	@Output() onBlur = new EventEmitter();
	@Output() onClear = new EventEmitter();
	@Output() tagsUpdate = new EventEmitter();


	clickListener = this.clickOutside.bind(this);

	public _value;
	get value(){
		return this._value;
	}
	set value(val){
		if(!val){
			this._value="";
		}else{
			this._value = val;
		}
		this.onChange(this._value);
	}
	selectedElement = -1; // The index of the selected element in filteredElements
	filteredElements = []; // The elements to display based on the query string
	elements = []; // options with an added display property
	toggleSelectPosition = 0;
	close = true;
	optionsSelected= [];
	focused = false;

	@Input() set options(value: IAutocompleteOption[]) {
		if (typeof value !== "undefined") {
			// Map options to a new array elements that has a display property the same as value if not already defined
			this.elements = value.map(el => {
				if (typeof el.display !== "undefined") {
					return el;
				} else {
					return { display: el.value, ...el };
				}
			});
			// If showAll is true than filtered elements is all elements
			if (this.showAll) {
				this.filteredElements = this.elements;
				if (this.maxResults > -1) {
					this.filteredElements = this.filteredElements.slice(0, this.maxResults);
				}
				if (!this.keepOpen) {
					this.close = true;
				}
			}
		}
	}

	get options(){
		return this.elements;
	}

	get open() {
		return !this.close && !this.hasSelectedItem;
	}

	get hasSelectedItem() {
		return this.selectedElement >= 0;
	}

	get hasFilteredItems() {
		return this.filteredElements.length > 0;
	}

	get hasNoResults() {
		return !this.hasFilteredItems && !this.value.includes(this.value) && this.value.length > this.triggerAfter;
	}

	@ViewChild("Card", { static: false}) $Card;
	@ViewChild("Card", { static: false, read:ElementRef }) cardResults;
	@ViewChild("InputSearch", { static: true }) inputSearch;

	constructor(private idService: IdService,  @Optional() @Self() public controlDirective: NgControl, private cdr:ChangeDetectorRef) {
		this.id = this.id ? this.id : this.idService.generate();
		if(this.controlDirective){
			controlDirective.valueAccessor = this;
		}
	}

	ngOnInit(){
		// // If showAll is true than filtered elements is all elements
		this.value = typeof this.value === undefined ? "" : this.value;
		if (this.showAll) {
			this.filteredElements = this.elements;
			if (this.maxResults > -1) {
				this.filteredElements = this.filteredElements.slice(0, this.maxResults);
			}
		}
		this.processValue();
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id);
		document.removeEventListener("click", this.clickListener);
	}

	// Function to call when the rating changes.
	onChange = (item) => {
	};
	// Function to call when the input is touched (when a star is clicked).
	onTouched = () => { };

	registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	writeValue(value: any): void {
		if(value){
			this.value = value;
			this.processValue();
			// this.changeDetection.markForCheck();
		}
	}

	processValue() {
		if (this.options) {
			let option;
			this.options.forEach((el, index) => {
				if (el.key == this.value) {
					// this.autocompleteUpdateValue(index)
					this.selectedElement = index ? index : this.toggleSelectPosition;
					option = el;
				}
			});
			if (option != null) {
				this.value = this.setQuery(option);
				this.selectItem(option)
				this.cdr.detectChanges();
			}
		}
	}

	clickOpen(event) {
		this.focused = true;
		this.close = event.target.id != this.inputSearch.id ? true : false;
		if (this.close) {
			document.removeEventListener('click', this.clickListener);
		} else {
			document.addEventListener('click', this.clickListener);
			// ensure that results is always starting from the first item at the top
			this.toggleSelectPosition = 0;
			this.$Card.body.nativeElement.scrollTop = 0;
			// make sure the results are properly reset
			this.autocompleteFilters(false);
		}
	//  if (this.showAll && this.filteredElements.length > 1 && this.selectedElement < 0) {
	// 		this.close = false;
	// 		document.addEventListener("click", this.clickListener);
	// 	}
	}

	// On click that isn't the inputsearch element
	Autocomplete_close(e, refId?) {
		this.close = (e.target.id !== refId ? true : false);
		document.removeEventListener("click", this.Autocomplete_close);
	}

	onBlurEvent(e){
		this.focused = false;
		this.onBlur.emit(e);
		this.onTouched();
	}

	clickOutside(e) {
		if (e === "escape") {
			this.close = true;
			this.cdr.detectChanges()
		}
		if (e.target.id !== this.inputSearch.id) {
			this.close = true
			this.cdr.detectChanges()
			document.removeEventListener("click", this.clickListener);
		} else {
			this.close = false;
		}
	}


	setQuery(chosenElement): string {
		let query = "";
		if (chosenElement.key) {
			query = this.displayKey
				? chosenElement.key
					.replace("<span class='query'>", "")
					.replace("</span>", "") + " - "
				: "";
			query += chosenElement.value
				.replace("<span class='query'>", "")
				.replace("</span>", "");
			chosenElement.key = chosenElement.key
				.replace("<span class='query'>", "")
				.replace("</span>", "");
			chosenElement.value = chosenElement.value
				.replace("<span class='query'>", "")
				.replace("</span>", "");
		} else {
			query = chosenElement;
		}
		return query;
	}

	// Called every time a value is added to the input, creates a new query that is used to filter elements
	queryUpdate(e, reset: boolean = true) {
		this.value = e;
		this.autocompleteFilters(reset);
		this.onInput.emit(e);
	}

	selectItem(query): void {
		this.selected.emit(query);
		let item = this.setQuery(query);
		// this.onChange(item);
		this.value = item;
		this.close = true;
	}

	autocompleteClear(e) {
		// Reset component
		this.queryUpdate("");
		this.selectItem("");
		this.onClear.emit(e);
		this.selectedElement = -1;
		this.filteredElements = this.showAll ? this.elements : [];
	}

	// Toggle the selected value from the dropdown depending on the key that is pressed
	$_Autocomplete_toggleSelect(key) {
		// if (this.showAll) {
		// 	this.close = false;
		// }
		const nbResults = this.filteredElements.length;
		if (nbResults > 0) {
			if (this.close && (key.toLowerCase().indexOf('down') > -1 || key.toLowerCase().indexOf('up') > -1)) {
				this.close = false;
				this.autocompleteFilters();
				this.cardResults.nativeElement.scrollTop = 0;
			// Down arrow pressed
			} else if (key.toLowerCase().indexOf('down') > -1 && this.toggleSelectPosition < nbResults - 1) {
				this.toggleSelectPosition++;
				this.cardResults.nativeElement.scrollTop = this.$Card.body.nativeElement.querySelector(".active").offsetTop;
			} else if (key.toLowerCase().indexOf("up") > -1 && this.toggleSelectPosition > 0) {
				this.toggleSelectPosition--;
				if(this.$Card.body.nativeElement.querySelector(".active").offsetTop){
					const scrollVal =this.$Card["cardResults"].nativeElement.querySelector(".active").offsetTop - this.$Card["cardResults"].nativeElement.querySelector(".active").offsetHeight * 2;
					this.cardResults.nativeElement.scrollTop = scrollVal;
				}
			} else if (key.toLowerCase() === "enter") {
				this.close = true;
				this.autocompleteUpdateValue();
				this.toggleSelectPosition = 0;
			} else if (key.toLowerCase() === "escape") {
				this.autocompleteClear(key);
			}
		}
	}

	// Filters the options to those that contain the query in one of the custom lookup properties
	autocompleteFilters(reset: boolean = false) {
		if(reset) {
			this.selectedElement = -1;
		}

		if (
			this.value.indexOf("<") === -1 &&
			this.value.indexOf(">") === -1 &&
			(this.showAll ||
				(this.value.length > this.triggerAfter &&
					this.selectedElement < 0))
		) {
			// For each element
			this.filteredElements = this.elements.filter(el => {
				// Check if the query is in any of the lookup values for each element
				let elementFiltered = false;
				this.customLookup.forEach(filter => {
					if (
						el[filter]
							.toLowerCase()
							.indexOf(this.value.toLowerCase()) > -1
					) {
						elementFiltered = true;
					}
				});
				this.close = false;
				return elementFiltered;
			});
			this.filteredElements = this.filteredElements.map(el => {
				const indexKey = el.key
					.toLowerCase()
					.indexOf(this.value.toLowerCase());
				const indexValue = el.display
					.toLowerCase()
					.indexOf(this.value.toLowerCase());
				const newKey = this.Autocomplete_formatDisplay(
					indexKey,
					el.key
				);
				const newValue = this.Autocomplete_formatDisplay(
					indexValue,
					el.display
				);
				return {
					...el,
					key: newKey,
					value: el.value,
					display: newValue
				};
			});
			// Slice the filtered elements to the max number of results in props
			if (this.maxResults > -1 && this.filteredElements.length) {
				this.filteredElements = this.filteredElements.slice(
					0,
					this.maxResults
				);
				this.close = false;
			}
		} else {
			this.filteredElements = [];
			this.toggleSelectPosition = 0;
			this.selectedElement = -1;
			this.close = true;
		}
	}

	// Formats the display property to outline the query in the val prop
	Autocomplete_formatDisplay(index, val) {
		const displayVal =
			index !== -1 && // Index of query was found
				val.indexOf(">", index) - val.indexOf("<", index) >= 0 && // Check if a closing chevron is before an opening one from the index we are
				(val.indexOf(">", index) !== -1 ||
					val
						.substring(index, val.indexOf(">", index))
						.indexOf("<", index) === -1) // Check if there is a closing chevron but no opening one coming
				? val.substring(0, index) +
				"<span class='query'>" +
				val.substring(index, index + this.value.length) +
				"</span>" +
				val.substring(index + this.value.length, val.length)
				: val;
		return displayVal;
	}

	// removes any spans used for to outline the query string in the key
	autoCompleteCleanKey(key) {
		return key.replace("<span class='query'>", "").replace("</span>", "");
	}

	// Updates the value in the input on click of the dropdown or on preselect
	autocompleteUpdateValue(position?) {
		this.selectedElement = position ? position : this.toggleSelectPosition;
		// Get the chosen element object based on it's index in filter elements
		let selectedElement = null;

		if (this.filteredElements.length > 0) {
			selectedElement = this.filteredElements[this.selectedElement];
		} else {
			selectedElement = this.options[this.selectedElement];
		}
		// if display key is true then the query is the chosen elements key with a dash before the value
		this.queryUpdate(this.setQuery(selectedElement), false);
		this.selectItem(selectedElement);
		this.close = true;

		if (this.tags || this.clearAfter) {
			this.queryUpdate("");
			this.close = true;
			this.toggleSelectPosition = 0;
			const hasSelectedElement = this.optionsSelected.filter(option => option.key === selectedElement.key);
			if (!hasSelectedElement.length) {
				this.optionsSelected.push({
					...selectedElement,
					selected: true
				});
				this.tagsUpdate.emit(this.optionsSelected);
			}
		}
	}

	activeDescendant() {
		if (this.open) {
			let selectedElement = this.id + "Option" +
				this.filteredElements[this.toggleSelectPosition].key;

			return selectedElement;
		} else {
			let selectedElement = null;
			if (this.filteredElements.length > 0) {
				selectedElement = this.selectedElement !== -1
					? this.id + "Option" +
					this.filteredElements[this.selectedElement].key
					: "";
			} else {
				selectedElement =
					this.selectedElement !== -1
						? `${this.id}Option${this.options[this.selectedElement].key}`
						: "";
			}
			return selectedElement;
		}
	}

	setInvalid(){
		let flag;
		this.controlDirective ? flag = this.controlDirective.invalid : flag = this.ariaInvalid;
		return flag;
	}

	heightGen() {
		return (this.height && typeof this.height !== "string") ? `${this.height}px` : this.height;
	}

	$_Autocomplete_updateSelected() {
		this.optionsSelected = this.optionsSelected.filter(option => option.selected);
		this.tagsUpdate.emit(this.optionsSelected)
	}
}
